import * as React from "react";

const EditIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      clipPath="url(#clip0_2899_16598)"
    >
      <path d="M6 13.5H3a.5.5 0 0 1-.5-.5v-2.793a.5.5 0 0 1 .146-.353l7.708-7.708a.5.5 0 0 1 .707 0l2.793 2.792a.5.5 0 0 1 0 .706zM13.5 13.5H6M8.5 4 12 7.5"></path>
    </g>
    <defs>
      <clipPath id="clip0_2899_16598">
        <path fill="#fff" d="M0 0h16v16H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default EditIcon;
